import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Megaphone, Check } from "lucide-react";
import { API } from "../../shared/config";
import { useAuth } from "../../contexts/AuthContext";

// Bandeau sous le menu : consignes du directeur adressées à mon groupe, tant que je ne les ai pas validées.
export const ConsignesBandeau = () => {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const charger = useCallback(() => axios.get(`${API}/consignes/miennes`).then(r => setItems(r.data || [])).catch(() => {}), []);

  useEffect(() => {
    if (!user) return;
    charger();
    const t = setInterval(charger, 120000);
    window.addEventListener('consignes-refresh', charger);
    return () => { clearInterval(t); window.removeEventListener('consignes-refresh', charger); };
  }, [user, charger]);

  const valider = async (c) => {
    setItems(prev => prev.filter(x => x.id !== c.id));
    try { await axios.post(`${API}/consignes/${c.id}/valider`); toast.success(c.validation === 'fait' ? 'Marqué comme fait' : 'Marqué comme lu'); }
    catch { toast.error("Impossible de valider la consigne"); charger(); }
  };

  if (!items.length) return null;
  return (
    <div className="mb-4 space-y-2" data-testid="consignes-bandeau">
      {items.map(c => (
        <div key={c.id} className="flex items-start gap-3 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 shadow-sm animate-in fade-in slide-in-from-top-1" data-testid={`consigne-${c.id}`}>
          <Megaphone className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <p className="text-[11px] font-extrabold uppercase tracking-wider text-amber-700">Consigne de {c.auteur}</p>
            <p className="text-sm text-amber-950 whitespace-pre-wrap break-words" data-testid={`consigne-texte-${c.id}`}>{c.texte}</p>
          </div>
          <button type="button" onClick={() => valider(c)} className="shrink-0 inline-flex items-center gap-1.5 rounded-xl bg-amber-600 hover:bg-amber-700 text-white text-xs font-bold px-3 py-2 transition-colors" data-testid={`consigne-valider-${c.id}`}>
            <Check className="h-3.5 w-3.5" /> {c.validation === 'fait' ? 'Fait' : 'Lu'}
          </button>
        </div>
      ))}
    </div>
  );
};
